/**
 * history_manager.js
 * 
 * ※※機能説明※※
 * 閲覧履歴に応じて該当教室の閲覧済みアイコンを表示
 * （現在は　教室情報、家庭教師情報に対応）
 * 
 * 主な利用方法
 * cart_manager.jsと同様、クラス名を指定する
 * （タグの種類は不問）
 * 
 * ※閲覧履歴をJS側から追加・削除する処理は備わっていません。
 * 　現在は追加・削除は各対象のコントローラー内で行っています。
 * 
 * 
 * ※※設定方法※※
 * ■閲覧済アイコンの表示が必要な箇所の設定
 * 　CLS_HISTORY_CHECKEDの要素にはkousha_id、もしくはtutor_idを指定する（必須）
 *   
 *   attributes:CartManager.ATTR_KOUSHA　→　【教室用】　要素にkousha_idを指定します。
 *   attributes:CartManager.ATTR_TUTOR　→　【家庭教師用】要素にtutor_idを指定します。
 *  
 *   class:CartManager.CLS_HISTORY_CHECKED　→　閲覧済アイコンを表示するCSSクラス
 *  
 *  ●タグ例
 *  <!-- 閲覧済みの場合は表示 -->
 *  <span class="sch-ic-checked js-history-manager-checked" kousha_id="{$kousha_item.kousha_id}" style="display:none">閲覧済</span>
 *  <!-- /閲覧済みの場合は表示 -->
 *  
 */



var HistoryManager = function(){};
HistoryManager.prototype = {
	koushaIds : new Array(),
	tutorIds : new Array(),
	
	
	/** 教室IDを指定する要素名 */
	ATTR_KOUSHA : 'kousha_id',
	/** 家庭教師IDを指定する要素名 */
	ATTR_TUTOR : 'tutor_id',
	
	/** 閲覧済みクラス名 */
	CLS_HISTORY_CHECKED : 'js-history-manager-checked',
	
	/** リスト取得URL */
	URL_GET_LIST : '/history/get_browse_ids/',
	
	/** 描画後に独自で描画したい処理がある場合はここに追加 */
	refleshFn:function(){},
	
	/**
	 * 初期処理
	 */
	initialize : function () {
		//閲覧履歴からリスト取得、アイコン表示
		this.getList(this._reflesh);
	},

	/**
	 * ajaxでリストを取得
	 */
	getList : function(afterFn){
		//getJSON内部でthisポインタが移動するため変数に格納
		var manager = this;
		 $.ajaxSetup({
		     cache: false
		   });
		var time = "?a=" + new Date().getTime();
		$.getJSON(manager.URL_GET_LIST + time, function(response){
			manager.koushaIds = response.history.kousha;
			manager.tutorIds = response.history.tutor;
			if ($.isFunction(afterFn)) {
				//データ取得後の処理がある場合は開始
				afterFn(manager);
			};
		});
	},

	/**
	 * 閲覧履歴取得後に行う処理
	 */
	_reflesh : function(manager){
		if (!manager) manager = this;
		
		//閲覧履歴付与処理対象のクラスをオブジェクトとして取得しループ処理
		var historyItem = $('.'+manager.CLS_HISTORY_CHECKED).map(function(index, el) { return $(el); }).get();
		$.each(historyItem, function() {
			 //閲覧履歴に対象のIDがある項目を状態変更
			manager._changeItem(this);
		});

		//オプションで追加される更新処理
		manager.refleshFn();
	},

	/**
	 * 閲覧履歴情報を基にアイテム変更
	 */
	_changeItem : function(item){
		var checkIndex = '-1';
		//要素に教室IDが指定されている場合は教室IDでカート情報とチェック
		if ($(item).attr(this.ATTR_KOUSHA)) {
			checkIndex = $.inArray($(item).attr(this.ATTR_KOUSHA), this.koushaIds);

		//要素に家庭教師IDが指定されている場合は家庭教師IDでカート情報とチェック
		} else if ($(item).attr(this.ATTR_TUTOR)) {
			checkIndex = $.inArray($(item).attr(this.ATTR_TUTOR), this.tutorIds);
		}

		try {
			if (checkIndex != '-1') {
				//閲覧履歴内に対象のIDがあれば閲覧履歴アイコン表示
				$(item).css('display', 'inline-block');
			} else {
				$(item).css('display', 'none');
			}
		} catch(e) {
			console.log('error : 子要素が指定されていません');
		}
	}
};

/**
 * ページロード後に初期化処理
 */
$(function(){
	historyM = new HistoryManager();
	historyM.initialize();
});

$(window).unload(function(){
//キャッシュ対象ページで「ブラウザ戻る」時にもページロード処理を走らせるために、unloadイベントで空functionを用意
});


/**
 * refleshFnを呼ぶ場合はクラスを継承するタイミングで独自functionを追加してください
historyCls = function() {};
$.extend(historyCls.prototype, historyManager.prototype,{
	refleshFn : function(){}
});
history = new historyCls();
*/
